const license = {
    not_installed: 'Chưa có license nào được cài đặt trên instance này.',
    invalid_key: 'License key không hợp lệ hoặc đã bị chỉnh sửa trái phép.',
    expired_key: 'License key đã hết hạn. Hãy lấy key mới và cài đặt lại.',
};
export default Object.freeze(license);
